import React, { useCallback, useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { selfServiceApi } from '../../services/selfServiceApi';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const SignStep: React.FC = () => {
  const { sessionId, goBack, flowId } = useWizard();
  const [redirecting, setRedirecting] = useState(false);
  const [title, setTitle] = useState('Signér');
  const [body, setBody] = useState<string[] | null>(null);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.sign).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  const handleSign = useCallback(async () => {
    if (!sessionId) {
      return;
    }

    setRedirecting(true);
    try {
      const { signUrl } = await selfServiceApi.getSignUrl(sessionId, flowId);
      window.location.href = `${signUrl}`;
    } catch {
      setRedirecting(false);
    }
  }, [flowId, sessionId]);

  useEffect(() => {
    const shouldAutoSign = (typeof navigator !== 'undefined' && (navigator as any).webdriver)
      || (typeof window !== 'undefined' && window.sessionStorage.getItem('autoAcceptGdpr') === 'true');

    if (shouldAutoSign && !redirecting) {
      const timer = window.setTimeout(() => {
        void handleSign();
      }, 100);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [handleSign, redirecting]);

  return (
    <StepContainer title={title}>
      {body && <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>}
      <button className="btn btn-primary" onClick={handleSign} disabled={redirecting}>
        {redirecting ? 'Viderestiller…' : 'Signér med MitID'}
      </button>
      <NavigationButtons onBack={goBack} showNext={false} />
    </StepContainer>
  );
};

export default SignStep;

